import { actionTypes } from '../constants/actionTypes';
import api from '../services';

export const fetchPageWP = (data) => {
    return (dispatch) => {
        dispatch(request({
            loading: true
        }));
        api.getPosts(data).then(response => {
            dispatch(success({
                data: response.data,
                error: null,
                loading: false
            }));
        }).catch(error => {
            dispatch(failure({
                data: [],
                error: error.message,
                loading: false
            }));
        });
    };

    function request(payload) {
        return {type: actionTypes.FETCH_WP_PAGES, payload};
    }

    function success(payload) {
        return {type: actionTypes.FETCH_WP_PAGES_SUCCESS, payload};
    }

    function failure(payload) {
        return {type: actionTypes.FETCH_WP_PAGES_FAIL, payload};
    }
};


// WEBPACK FOOTER //
// ./src/actions/pages.tsx